module.exports = __webpack_public_path__ + "img/issues.b4a51046.svg";